module.exports = __webpack_public_path__ + "static/media/shequ-title-4.bf980ff8.png";